import qs from 'qs'

export default {
  toObject(obj: Record<string, any>): Record<string, any> {
    const result: Record<string, any> = {}

    Object.entries(obj || {}).forEach(([key, value]) => {
      const splitKey = key.split(/[[\]]/).filter(Boolean)
      if (splitKey.length > 1) {
        return splitKey.reduce((acc: Record<string, any>, keyPart: string, currentIndex: number) => {
          if (currentIndex >= splitKey.length - 1) {
            acc[keyPart] = value
          }
          if (!Reflect.has(acc, keyPart)) {
            acc[keyPart] = {}
          }
          return acc[keyPart]
        }, result)
      }
      result[key] = value
    })

    return result
  },
  toObjectFromQs(string: string): Record<string, any> {
    return qs.parse(string)
  },
  toQueryString(obj: Record<string, any>): string {
    return qs.stringify(obj)
  },
}
